export const DIALOG_ID = 'F5-select-list-modal';

export const INPUT_PORTAL_ID = 'F5-select-list-input-portal';
